var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1758240828819,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 112588,
    width: 16,
    height: 16,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M511.395514 0C229.704841 0 0 229.704841 0 511.395514s229.704841 511.395514 511.395514 511.395513c282.899646 0 511.395514-229.704841 511.395513-511.395513S794.295159 0 511.395514 0z m0 882.550177c-205.525384 0-371.154664-165.62928-371.154664-371.154663s165.62928-371.154664 371.154664-371.154664S882.550177 307.079103 882.550177 511.395514 716.920897 882.550177 511.395514 882.550177z",
    "p-id": 112589,
    fill: "#A855F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M567.008264 563.381346h-36.269185c-12.089728 0-21.761511-9.671783-21.761511-21.761511V236.958678c0-12.089728 9.671783-21.761511 21.761511-21.761512h36.269185c12.089728 0 21.761511 9.671783 21.761512 21.761512v304.661157c0 12.089728-9.671783 21.761511-21.761512 21.761511z",
    "p-id": 112590,
    fill: "#A855F7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M588.769776 501.723731V544.03778c0 10.880756-8.46281 19.343566-19.343566 19.343566H350.602125c-10.880756 0-19.343566-8.46281-19.343565-19.343566v-42.314049c0-10.880756 8.46281-19.343566 19.343565-19.343566h220.033058c9.671783 0 18.134593 8.46281 18.134593 19.343566z",
    "p-id": 112591,
    fill: "#A855F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockPurple);
export default __webpack_public_path__ + "static/media/clock-purple.57fc2780.svg";
export { ForwardRef as ReactComponent };